import { addDays, format, subDays } from 'date-fns';

import type { IScheduleStatusData } from '@/components/agent/dashboard/types';

import {
  SCHEDULE_STATUS_DAYS_IN_FUTURE,
  SCHEDULE_STATUS_DAYS_IN_PAST,
  YEAR_MONTH_DAY_FORMAT,
} from '@/config/variables';
import { getBoundaryBlocksForDate } from '@/helpers';

const CONTRACTS_REQUIREMENTS_PAGE_SIZE = 5;

const dateKeys = [
  ...Array.from(Array(SCHEDULE_STATUS_DAYS_IN_PAST).keys())
    .map(key => subDays(Date.now(), key + 1))
    .reverse(),
  new Date(),
  ...Array.from(Array(SCHEDULE_STATUS_DAYS_IN_FUTURE).keys()).map(key => addDays(Date.now(), key + 1)),
];

const SCHEDULE_STATUS_BASE_LIST = (): Readonly<IScheduleStatusData> =>
  Object.freeze(
    dateKeys.reduce<IScheduleStatusData>((acc, key) => {
      const dateKey = new Date(format(key, YEAR_MONTH_DAY_FORMAT));
      const { startBlock, endBlock } = getBoundaryBlocksForDate(dateKey);
      acc[dateKey.toDateString()] = Object.freeze({ total: 0, unmet: 0, startBlock: startBlock, endBlock: endBlock });
      return acc;
    }, {}),
  );

export { SCHEDULE_STATUS_BASE_LIST, CONTRACTS_REQUIREMENTS_PAGE_SIZE };
